
<template>
    <div>
        <template>
            <tabs fill class="flex-column flex-md-row">
                <card shadow>
                    <tab-pane 
                        title="Medical Applications"
                        @tab-activated="triggerMedicalApplications" 
                    >
                        <span slot="title">
                            <i class="ni ni-books"></i>
                            Medical Applications
                        </span>
                        <!-- import Pending Applications template here --> 
                        <MedicalPendingApplications 
                            :type="'medical'"
                            :visitStatus="visitStatus"
                            ref="callMedicalApplications"
                        />
                    </tab-pane>

                    <tab-pane 
                        title="Dental Applications"
                        @tab-activated="triggerDentalApplications" 
                    >
                        <span slot="title">
                            <i class="ni ni-badge"></i>
                            Dental Applications
                        </span>
                        <!-- import Rejected Applications template here --> 
                        <!-- <DentalPendingApplications /> --> 
                        <MedicalPendingApplications 
                            :type="'dental'"
                            :visitStatus="visitStatus"
                            ref="callDentalApplications"
                        />
                    </tab-pane>
                </card>
            </tabs>
        </template>
    </div>
</template>
<script>
    import MedicalPendingApplications from './PendingApplications/MedicalPendingApplications';

    export default {
        name: 'PendingApplications',
        props: ['visitStatus'],
        components: {
            MedicalPendingApplications
        },
        methods: {
            triggerMedicalApplications() {
                if (this.$refs.callMedicalApplications && this.$refs.callMedicalApplications.loadAplications) {
                    this.$refs.callMedicalApplications.loadAplications();
                }
            },
            triggerDentalApplications() {
                if (this.$refs.callDentalApplications && this.$refs.callDentalApplications.loadAplications) {
                    this.$refs.callDentalApplications.loadAplications();
                }
            },
        }
    };
</script>
<style></style>
